/**
 * Configuración de categorías basada en onelectronics.com.ar
 * Estas categorías coinciden exactamente con las del mayorista para evitar
 * discrepancias durante la sincronización de la API.
 */

// Categorías que se muestran en la interfaz
export const CATEGORIES = [
  "Todo",
  "ACCESORIOS PC",
  "ACCESORIOS VEHICULOS",
  "AURICULARES",
  "BALANZA",
  "BELLEZA Y SALUD",
  "CAMARAS DE SEGURIDAD",
  "CARGADORES Y ADAPTADORES",
  "CONVERTIDORES, CONSOLAS, TV",
  "FERRETERIA",
  "GRIFERIA",
  "HOGAR",
  "ILUMINACION",
  "JOYSTICK",
  "LIBRERIA Y MOCHILAS",
  "MICROFONOS Y PARLANTES",
  "NIÑOS",
  "OTROS",
  "PENDRIVE Y TARJETAS DE MEMORIAS",
  "RELOJES",
  "SOPORTES Y TRIPODES",
  "VASOS Y TERMOS",
  "KITS",
];

// Mapeo de categorías del mayorista a nuestras categorías normalizadas
// Útil si la API trae variaciones en los nombres
export const CATEGORY_ALIASES = {
  // Variantes comunes que pueden venir de la API
  "ACCESORIOS DE PC": "ACCESORIOS PC",
  "ACCESORIOS PARA PC": "ACCESORIOS PC",
  "ACCESORIOS AUTOS": "ACCESORIOS VEHICULOS",
  "ACCESORIOS PARA VEHICULOS": "ACCESORIOS VEHICULOS",
  "ACCESORIOS VEHICULOS, MOTOS Y BICIS": "ACCESORIOS VEHICULOS",
  "AURICULAR": "AURICULARES",
  "AURICULARES INALAMBRICOS": "AURICULARES",
  "BELLEZA": "BELLEZA Y SALUD",
  "SALUD": "BELLEZA Y SALUD",
  "CAMARAS": "CAMARAS DE SEGURIDAD",
  "CAMARAS DE SEGURIDAD": "CAMARAS DE SEGURIDAD",
  "CARGADORES": "CARGADORES Y ADAPTADORES",
  "ADAPTADORES": "CARGADORES Y ADAPTADORES",
  "CARGADORES, CABLES Y ADAPTADORES": "CARGADORES Y ADAPTADORES",
  "CONVERTIDORES": "CONVERTIDORES, CONSOLAS, TV",
  "CONSOLAS": "CONVERTIDORES, CONSOLAS, TV",
  "TV": "CONVERTIDORES, CONSOLAS, TV",
  "CONVERTIDORES, CONSOLAS, TV Y PILAS": "CONVERTIDORES, CONSOLAS, TV",
  "CELULARES Y TELEVISORES": "CONVERTIDORES, CONSOLAS, TV",
  "HERRAMIENTA": "HERRAMIENTAS",
  "ILUMINACIÓN": "ILUMINACION",
  "LUCES": "ILUMINACION",
  "ACCESORIOS PARA EVENTOS Y FOCOS": "ILUMINACION",
  "ACCESORIOS PARA ENVENTOS Y FOCOS": "ILUMINACION",
  "JOYSTICKS": "JOYSTICK",
  "MANDOS": "JOYSTICK",
  "LIBRERIA": "LIBRERIA Y MOCHILAS",
  "MOCHILAS": "LIBRERIA Y MOCHILAS",
  "ESCOLARES": "LIBRERIA Y MOCHILAS",
  "LIBRERIA, MOCHILA,BOLSO-COTILLON": "LIBRERIA Y MOCHILAS",
  "COTILLON": "LIBRERIA Y MOCHILAS",
  "BOLSOS": "LIBRERIA Y MOCHILAS",
  "MICROFONOS": "MICROFONOS Y PARLANTES",
  "MICROFONO": "MICROFONOS Y PARLANTES",
  "PARLANTE": "PARLANTES",
  "SPEAKERS": "PARLANTES",
  "PENDRIVE": "PENDRIVE Y TARJETAS DE MEMORIAS",
  "MEMORIAS": "PENDRIVE Y TARJETAS DE MEMORIAS",
  "TARJETAS DE MEMORIA": "PENDRIVE Y TARJETAS DE MEMORIAS",
  "RELOJ": "RELOJES",
  "SMARTWATCH": "RELOJES",
  "SOPORTES": "SOPORTES Y TRIPODES",
  "TRIPODES": "SOPORTES Y TRIPODES",
  "TRIPODE": "SOPORTES Y TRIPODES",
  "VASOS": "VASOS Y TERMOS",
  "TERMOS": "VASOS Y TERMOS",
  "BOTELLAS": "VASOS Y TERMOS",
  "JUGUETES": "NIÑOS",
  "MASCOTAS": "OTROS",
  "INFORMATICA": "ACCESORIOS PC",
  "ELECTRODOMESTICOS": "HOGAR",
  "GRIFERIA": "FERRETERIA",
  "BALANZA": "HOGAR",
  "BALANZA ": "HOGAR",
  "SIN CATEGORIA": "OTROS",
  "Sin categoria": "OTROS",
  "INDUMENTARIA": "OTROS",
  "ROPA": "OTROS",
};

// Categorías que no existen en el mayorista pero queremos mostrar igual
export const EXTRA_CATEGORIES = [];

// Función para normalizar el nombre de categoría
export const normalizeCategory = (rawCategory) => {
  if (!rawCategory || typeof rawCategory !== "string") {
    return "OTROS";
  }
  
  const trimmed = rawCategory.trim().toUpperCase();
  
  // Si ya es una categoría válida, devolverla tal cual
  const validCategory = CATEGORIES.find(
    (cat) => cat !== "Todo" && cat.toUpperCase() === trimmed
  );
  if (validCategory) {
    return validCategory;
  }
  
  // Buscar en aliases
  const aliasKey = Object.keys(CATEGORY_ALIASES).find(
    (key) => key.toUpperCase() === trimmed
  );
  if (aliasKey) {
    return CATEGORY_ALIASES[aliasKey];
  }
  
  // Si no coincide con nada, devolver OTROS
  return "OTROS";
};

// Obtener todas las categorías para mostrar en el filtro (sin "Todo")
export const getFilterCategories = () => CATEGORIES.filter((cat) => cat !== "Todo");

export default CATEGORIES;
